import React  from 'react';
import BooleanComponentProto from './boolean-proto.jsx';


export default function renderBooleanInFormNew(id, props) {
    return <BooleanComponentProto renderMode="form-new" id={id} {...props} />;
}